import styled from 'styled-components';

import { IconDownload } from '@components/icons/download';
import { IconFile } from '@components/icons/file';
import { IconTrash } from '@components/icons/trash';
import { theme } from '@styles/theme';
import { transitionStandard } from '@utils/transitions';

import { Button } from '../button';
import { Stack } from '../stack';
import { Text } from '../text';

export interface FileBoxProps {
  onClick: () => void;
  fileName: string | undefined;
  path: any;
  removeAction?: (obj: any) => void;
  downloadText: string;
  removeText: string;
  fileObj: any;
}

export function FileBox(props: FileBoxProps) {
  const { onClick, fileName, downloadText, removeText, path, removeAction, fileObj } = props;

  return (
    <StyledFileBox onClick={onClick}>
      <IconFileContainer>
        <Stack space={2} orientation="horizontal">
          <IconFile color="elementBlue100" />
          <Text
            style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
            text={fileName || ''}
          />
        </Stack>
      </IconFileContainer>
      <ActionsContainer className="icon-box">
        <Button
          iconLeft={<IconDownload />}
          tooltip={downloadText}
          variant="ghost"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            window.location = path;
          }}
        />
        {removeAction && (
          <Button
            iconLeft={<IconTrash />}
            tooltip={removeText}
            variant="ghost"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              removeAction(fileObj);
            }}
          />
        )}
      </ActionsContainer>
    </StyledFileBox>
  );
}

const IconFileContainer = styled.div({
  display: 'flex',
  alignItems: 'center',
  overflow: 'hidden',
  height: '2.5rem',
});

const ActionsContainer = styled.div({
  display: 'flex',
});

const StyledFileBox = styled.div((p) => ({
  backgroundColor: theme.color.white100,
  border: '1px solid',
  borderColor: theme.color.purple10,
  borderRadius: '0.25rem',
  boxSizing: 'border-box',
  color: theme.color.purple100,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  paddingRight: '0.5rem',
  paddingLeft: '1rem',
  transition: transitionStandard('all'),
  ':hover': {
    color: theme.color.elementBlue100,
    borderColor: theme.color.purple20,
    cursor: 'pointer',
    boxShadow: theme.shadow.low,
    '.icon-box': {
      display: 'flex',
    },
  },
  width: '100%',
  overflow: 'hidden',
  height: '3.5rem',
  textOverflow: 'ellipsis',
  svg: {
    minWidth: '1.5rem',
  },
  '.icon-box': {
    display: 'none',
  },
  button: {
    minWidth: '2.5rem',
  },
}));
